import * as React from "react";
import { Col, Row } from "reactstrap";
import { SelectOptions } from "../../interfaces/CoreInterfaces";
import { RenderSettings } from "../../interfaces/WidgetSettingsInterfaces";
import { DashboardManagementModal } from "./Modals/DashboardManagementModal";


interface DashboardHeaderRowProps {
  dashboardTitle: string;
  settingsString: string;
  displayList: { [key: number]: JSX.Element };
  widgetList: Array<SelectOptions>;
  updateUI: (settings: RenderSettings) => void;
}

export default class DashboardHeaderRow extends React.Component<DashboardHeaderRowProps, {}> {
  widgetSettingsModalRef = React.createRef<DashboardManagementModal>();

  render(): JSX.Element {
    return (<>
      <DashboardManagementModal ref={this.widgetSettingsModalRef} />
      <Row>
        <Col>
          <div style={{ display: "block", height: "6vh", float: "left", width: "70vw", paddingTop: "1vh" }}>
            <h4 style={{ marginLeft: "9%", width: "100%", textAlign: "center" }}>{this.props.dashboardTitle}</h4>
          </div>
        </Col>
        <Col>
          <div style={{ display: "block", height: "6vh", float: "left", marginLeft: "7%" }}>
            <input type="button" className="standardInput" value="Edit Widgets" onClick={() => this.widgetSettingsModalRef.current.show(this.props.settingsString, this.props.widgetList, this.props.updateUI)} />
          </div>
        </Col>
        <div style={{ float: "none" }}></div>
      </Row>
    </>)
  }
}